// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PYFy","badges":"styles_badges__3h7Vp"};